export const breedList = [
  {
    value: "English Pointer",
    label: "English Pointer",
  },
  {
    value: "English Bulldog",
    label: "English Bulldog",
  },
  {
    value: "Cocker Spaniel",
    label: "Cocker Spaniel",
  },
  {
    value: "English Setter",
    label: "English Setter",
  },
  {
    value: "Kerry Blue Terrier",
    label: "Kerry Blue Terrier",
  },
  {
    value: "Cairn Terrier",
    label: "Cairn Terrier",
  },
  {
    value: "English Cocker Spaniel",
    label: "English Cocker Spaniel",
  },
  {
    value: "Gordon Setter",
    label: "Gordon Setter",
  },
  {
    value: "Airedale Terrier",
    label: "Airedale Terrier",
  },
  {
    value: "Australian Terrier",
    label: "Australian Terrier",
  },
  {
    value: "Bedlington Terrier",
    label: "Bedlington Terrier",
  },
  {
    value: "Border Terrier",
    label: "Border Terrier",
  },
  {
    value: "Bull Terrier",
    label: "Bull Terrier",
  },
  {
    value: "Fox Terrier (Smooth)",
    label: "Fox Terrier (Smooth)",
  },
  {
    value: "English Toy Terrier (Black &Tan)",
    label: "English Toy Terrier (Black &Tan)",
  },
  {
    value: "Swedish Vallhund",
    label: "Swedish Vallhund",
  },
  {
    value: "Belgian Shepherd Dog",
    label: "Belgian Shepherd Dog",
  },
  {
    value: "Old English Sheepdog",
    label: "Old English Sheepdog",
  },
  {
    value: "Griffon Nivernais",
    label: "Griffon Nivernais",
  },
  {
    value: "Briquet Griffon Vendeen",
    label: "Briquet Griffon Vendeen",
  },
  {
    value: "Ariegeois",
    label: "Ariegeois",
  },
  {
    value: "Gascon Saintongeois",
    label: "Gascon Saintongeois",
  },
  {
    value: "Great Gascony Blue",
    label: "Great Gascony Blue",
  },
  {
    value: "Poitevin",
    label: "Poitevin",
  },
  {
    value: "Billy",
    label: "Billy",
  },
  {
    value: "Artois Hound",
    label: "Artois Hound",
  },
  {
    value: "Porcelaine",
    label: "Porcelaine",
  },
  {
    value: "Small Blue Gascony",
    label: "Small Blue Gascony",
  },
  {
    value: "Blue Gascony Griffon",
    label: "Blue Gascony Griffon",
  },
  {
    value: "Grand Basset Griffon Vendeen",
    label: "Grand Basset Griffon Vendeen",
  },
  {
    value: "Norman Artesien Basset",
    label: "Norman Artesien Basset",
  },
  {
    value: "Blue Gascony Basset",
    label: "Blue Gascony Basset",
  },
  {
    value: "Basset Fauve De Bretagne",
    label: "Basset Fauve De Bretagne",
  },
  {
    value: "Portuguese Water Dog",
    label: "Portuguese Water Dog",
  },
  {
    value: "Welsh Corgi (Cardigan)",
    label: "Welsh Corgi (Cardigan)",
  },
  {
    value: "Welsh Corgi (Pembroke)",
    label: "Welsh Corgi (Pembroke)",
  },
  {
    value: "Irish Soft Coated Wheaten Terrier",
    label: "Irish Soft Coated Wheaten Terrier",
  },
  {
    value: "Yugoslavian Shepherd Dog - Sharplanina",
    label: "Yugoslavian Shepherd Dog - Sharplanina",
  },
  {
    value: "Jamthund",
    label: "Jamthund",
  },
  {
    value: "Basenji",
    label: "Basenji",
  },
  {
    value: "Berger De Beauce",
    label: "Berger De Beauce",
  },
  {
    value: "Bernese Mountain Dog",
    label: "Bernese Mountain Dog",
  },
  {
    value: "Appenzell Cattle Dog",
    label: "Appenzell Cattle Dog",
  },
  {
    value: "Entlebuch Cattle Dog",
    label: "Entlebuch Cattle Dog",
  },
  {
    value: "Karelian Bear Dog",
    label: "Karelian Bear Dog",
  },
  {
    value: "Finnish Spitz",
    label: "Finnish Spitz",
  },
  {
    value: "Newfoundland",
    label: "Newfoundland",
  },
  {
    value: "Finnish Hound",
    label: "Finnish Hound",
  },
  {
    value: "Polish Hound",
    label: "Polish Hound",
  },
  {
    value: "Komondor",
    label: "Komondor",
  },
  {
    value: "Kuvasz",
    label: "Kuvasz",
  },
  {
    value: "Puli",
    label: "Puli",
  },
  {
    value: "Pumi",
    label: "Pumi",
  },
  {
    value: "Hungarian Short-Haired Pointer (Vizsla)",
    label: "Hungarian Short-Haired Pointer (Vizsla)",
  },
  {
    value: "Great Swiss Mountain Dog",
    label: "Great Swiss Mountain Dog",
  },
  {
    value: "Swiss Hound",
    label: "Swiss Hound",
  },
  {
    value: "Small Swiss Hound",
    label: "Small Swiss Hound",
  },
  {
    value: "St. Bernard",
    label: "St. Bernard",
  },
  {
    value: "Coarse-Haired Styrian Hound",
    label: "Coarse-Haired Styrian Hound",
  },
  {
    value: "Austrian Black And Tan Hound",
    label: "Austrian Black And Tan Hound",
  },
  {
    value: "Austrian  Pinscher",
    label: "Austrian  Pinscher",
  },
  {
    value: "Maltese",
    label: "Maltese",
  },
  {
    value: "Fawn Brittany Griffon",
    label: "Fawn Brittany Griffon",
  },
  {
    value: "Petit Basset Griffon Vendeen",
    label: "Petit Basset Griffon Vendeen",
  },
  {
    value: "Tyrolean Hound",
    label: "Tyrolean Hound",
  },
  {
    value: "Lakeland Terrier",
    label: "Lakeland Terrier",
  },
  {
    value: "Manchester Terrier",
    label: "Manchester Terrier",
  },
  {
    value: "Norwich Terrier",
    label: "Norwich Terrier",
  },
  {
    value: "Scottish Terrier",
    label: "Scottish Terrier",
  },
  {
    value: "Sealyham Terrier",
    label: "Sealyham Terrier",
  },
  {
    value: "Skye Terrier",
    label: "Skye Terrier",
  },
  {
    value: "Staffordshire Bull Terrier",
    label: "Staffordshire Bull Terrier",
  },
  {
    value: "Continental Toy Spaniel",
    label: "Continental Toy Spaniel",
  },
  {
    value: "Welsh Terrier",
    label: "Welsh Terrier",
  },
  {
    value: "Griffon Bruxellois",
    label: "Griffon Bruxellois",
  },
  {
    value: "Griffon Belge",
    label: "Griffon Belge",
  },
  {
    value: "Petit Brabancon",
    label: "Petit Brabancon",
  },
  {
    value: "Schipperke",
    label: "Schipperke",
  },
  {
    value: "Bloodhound",
    label: "Bloodhound",
  },
  {
    value: "West Highland White Terrier",
    label: "West Highland White Terrier",
  },
  {
    value: "Yorkshire Terrier",
    label: "Yorkshire Terrier",
  },
  {
    value: "Catalan Sheepdog",
    label: "Catalan Sheepdog",
  },
  {
    value: "Shetland Sheepdog",
    label: "Shetland Sheepdog",
  },
  {
    value: "Ibizan Podenco",
    label: "Ibizan Podenco",
  },
  {
    value: "Burgos Pointing Dog",
    label: "Burgos Pointing Dog",
  },
  {
    value: "Spanish Mastiff",
    label: "Spanish Mastiff",
  },
  {
    value: "Pyrenean Mastiff",
    label: "Pyrenean Mastiff",
  },
  {
    value: "Portuguese Sheepdog",
    label: "Portuguese Sheepdog",
  },
  {
    value: "Portuguese Warren Hound-Portuguese Podengo",
    label: "Portuguese Warren Hound-Portuguese Podengo",
  },
  {
    value: "Brittany Spaniel",
    label: "Brittany Spaniel",
  },
  {
    value: "Rafeiro Of Alentejo",
    label: "Rafeiro Of Alentejo",
  },
  {
    value: "German Spitz",
    label: "German Spitz",
  },
  {
    value: "German Wire- Haired Pointing Dog",
    label: "German Wire- Haired Pointing Dog",
  },
  {
    value: "Weimaraner",
    label: "Weimaraner",
  },
  {
    value: "Westphalian Dachsbracke",
    label: "Westphalian Dachsbracke",
  },
  {
    value: "French Bulldog",
    label: "French Bulldog",
  },
  {
    value: "Kleiner Munsterlander",
    label: "Kleiner Munsterlander",
  },
  {
    value: "German Hunting Terrier",
    label: "German Hunting Terrier",
  },
  {
    value: "German Spaniel",
    label: "German Spaniel",
  },
  {
    value: "French Water Dog",
    label: "French Water Dog",
  },
  {
    value: "Blue Picardy Spaniel",
    label: "Blue Picardy Spaniel",
  },
  {
    value: "Wire-Haired Pointing Griffon Korthals",
    label: "Wire-Haired Pointing Griffon Korthals",
  },
  {
    value: "Picardy Spaniel",
    label: "Picardy Spaniel",
  },
  {
    value: "Clumber Spaniel",
    label: "Clumber Spaniel",
  },
  {
    value: "Curly Coated Retriever",
    label: "Curly Coated Retriever",
  },
  {
    value: "Golden Retriever",
    label: "Golden Retriever",
  },
  {
    value: "Briard",
    label: "Briard",
  },
  {
    value: "Pont-Audemer Spaniel",
    label: "Pont-Audemer Spaniel",
  },
  {
    value: "Saint Germain Pointer",
    label: "Saint Germain Pointer",
  },
  {
    value: "Dogue De Bordeaux",
    label: "Dogue De Bordeaux",
  },
  {
    value: "Deutsch Langhaar",
    label: "Deutsch Langhaar",
  },
  {
    value: "Large Munsterlander",
    label: "Large Munsterlander",
  },
  {
    value: "German Short- Haired Pointing Dog",
    label: "German Short- Haired Pointing Dog",
  },
  {
    value: "Irish Red Setter",
    label: "Irish Red Setter",
  },
  {
    value: "Flat Coated Retriever",
    label: "Flat Coated Retriever",
  },
  {
    value: "Labrador Retriever",
    label: "Labrador Retriever",
  },
  {
    value: "Field Spaniel",
    label: "Field Spaniel",
  },
  {
    value: "Irish Water Spaniel",
    label: "Irish Water Spaniel",
  },
  {
    value: "English Springer Spaniel",
    label: "English Springer Spaniel",
  },
  {
    value: "Welsh Springer Spaniel",
    label: "Welsh Springer Spaniel",
  },
  {
    value: "Sussex Spaniel",
    label: "Sussex Spaniel",
  },
  {
    value: "King Charles Spaniel",
    label: "King Charles Spaniel",
  },
  {
    value: "Smalandsstovare",
    label: "Smalandsstovare",
  },
  {
    value: "Drever",
    label: "Drever",
  },
  {
    value: "Schillerstovare",
    label: "Schillerstovare",
  },
  {
    value: "Hamiltonstovare",
    label: "Hamiltonstovare",
  },
  {
    value: "French Pointing Dog - Gascogne Type",
    label: "French Pointing Dog - Gascogne Type",
  },
  {
    value: "French Pointing Dog - Pyrenean Type",
    label: "French Pointing Dog - Pyrenean Type",
  },
  {
    value: "Swedish Lapphund",
    label: "Swedish Lapphund",
  },
  {
    value: "Cavalier King Charles Spaniel",
    label: "Cavalier King Charles Spaniel",
  },
  {
    value: "Pyrenean Mountain Dog",
    label: "Pyrenean Mountain Dog",
  },
  {
    value: "Pyrenean Sheepdog - Smooth Faced",
    label: "Pyrenean Sheepdog - Smooth Faced",
  },
  {
    value: "Irish Terrier",
    label: "Irish Terrier",
  },
  {
    value: "Boston Terrier",
    label: "Boston Terrier",
  },
  {
    value: "Long-Haired Pyrenean Sheepdog",
    label: "Long-Haired Pyrenean Sheepdog",
  },
  {
    value: "Slovakian Chuvach",
    label: "Slovakian Chuvach",
  },
  {
    value: "Dobermann",
    label: "Dobermann",
  },
  {
    value: "Boxer",
    label: "Boxer",
  },
  {
    value: "Leonberger",
    label: "Leonberger",
  },
  {
    value: "Rhodesian Ridgeback",
    label: "Rhodesian Ridgeback",
  },
  {
    value: "Rottweiler",
    label: "Rottweiler",
  },
  {
    value: "Dachshund",
    label: "Dachshund",
  },
  {
    value: "Bulldog",
    label: "Bulldog",
  },
  {
    value: "Serbian Hound",
    label: "Serbian Hound",
  },
  {
    value: "Istrian Short-Haired Hound",
    label: "Istrian Short-Haired Hound",
  },
  {
    value: "Istrian Wire-Haired Hound",
    label: "Istrian Wire-Haired Hound",
  },
  {
    value: "Dalmatian",
    label: "Dalmatian",
  },
  {
    value: "Posavatz Hound",
    label: "Posavatz Hound",
  },
  {
    value: "Bosnian Broken-Haired Hound - Called Barak",
    label: "Bosnian Broken-Haired Hound - Called Barak",
  },
  {
    value: "Collie Rough",
    label: "Collie Rough",
  },
  {
    value: "Bullmastiff",
    label: "Bullmastiff",
  },
  {
    value: "Greyhound",
    label: "Greyhound",
  },
  {
    value: "English Foxhound",
    label: "English Foxhound",
  },
  {
    value: "Irish Wolfhound",
    label: "Irish Wolfhound",
  },
  {
    value: "Beagle",
    label: "Beagle",
  },
  {
    value: "Whippet",
    label: "Whippet",
  },
  {
    value: "Basset Hound",
    label: "Basset Hound",
  },
  {
    value: "Deerhound",
    label: "Deerhound",
  },
  {
    value: "Italian Spinone",
    label: "Italian Spinone",
  },
  {
    value: "German Shepherd Dog",
    label: "German Shepherd Dog",
  },
  {
    value: "American Cocker Spaniel",
    label: "American Cocker Spaniel",
  },
  {
    value: "Dandie Dinmont Terrier",
    label: "Dandie Dinmont Terrier",
  },
  {
    value: "Fox Terrier (Wire)",
    label: "Fox Terrier (Wire)",
  },
  {
    value: "Castro Laboreiro Dog",
    label: "Castro Laboreiro Dog",
  },
  {
    value: "Bouvier Des Ardennes",
    label: "Bouvier Des Ardennes",
  },
  {
    value: "Poodle",
    label: "Poodle",
  },
  {
    value: "Estrela Mountain Dog",
    label: "Estrela Mountain Dog",
  },
  {
    value: "French Spaniel",
    label: "French Spaniel",
  },
  {
    value: "Picardy Sheepdog",
    label: "Picardy Sheepdog",
  },
  {
    value: "Ariege Pointing Dog",
    label: "Ariege Pointing Dog",
  },
  {
    value: "Bourbonnais Pointing Dog",
    label: "Bourbonnais Pointing Dog",
  },
  {
    value: "Auvergne Pointer",
    label: "Auvergne Pointer",
  },
  {
    value: "Giant Schnauzer",
    label: "Giant Schnauzer",
  },
  {
    value: "Schnauzer",
    label: "Schnauzer",
  },
  {
    value: "Miniature Schnauzer",
    label: "Miniature Schnauzer",
  },
  {
    value: "German Pinscher",
    label: "German Pinscher",
  },
  {
    value: "Miniature Pinscher",
    label: "Miniature Pinscher",
  },
  {
    value: "Affenpinscher",
    label: "Affenpinscher",
  },
  {
    value: "Portuguese Pointing Dog",
    label: "Portuguese Pointing Dog",
  },
  {
    value: "Sloughi",
    label: "Sloughi",
  },
  {
    value: "Finnish Lapponian Dog",
    label: "Finnish Lapponian Dog",
  },
  {
    value: "Hovawart",
    label: "Hovawart",
  },
  {
    value: "Bouvier Des Flandres",
    label: "Bouvier Des Flandres",
  },
  {
    value: "Kromfohrlander",
    label: "Kromfohrlander",
  },
  {
    value: "Borzoi - Russian Hunting Sighthound",
    label: "Borzoi - Russian Hunting Sighthound",
  },
  {
    value: "Bergamasco Shepherd Dog",
    label: "Bergamasco Shepherd Dog",
  },
  {
    value: "Italian Volpino",
    label: "Italian Volpino",
  },
  {
    value: "Bolognese",
    label: "Bolognese",
  },
  {
    value: "Neapolitan Mastiff",
    label: "Neapolitan Mastiff",
  },
  {
    value: "Italian Rough-Haired Segugio",
    label: "Italian Rough-Haired Segugio",
  },
  {
    value: "Cirneco Dell'Etna",
    label: "Cirneco Dell'Etna",
  },
  {
    value: "Italian Sighthound",
    label: "Italian Sighthound",
  },
  {
    value: "Maremma And The Abruzzes Sheepdog",
    label: "Maremma And The Abruzzes Sheepdog",
  },
  {
    value: "Italian Pointing Dog",
    label: "Italian Pointing Dog",
  },
  {
    value: "Norwegian Hound",
    label: "Norwegian Hound",
  },
  {
    value: "Spanish Hound",
    label: "Spanish Hound",
  },
  {
    value: "Chow Chow",
    label: "Chow Chow",
  },
  {
    value: "Japanese Chin",
    label: "Japanese Chin",
  },
  {
    value: "Pekingese",
    label: "Pekingese",
  },
  {
    value: "Shih Tzu",
    label: "Shih Tzu",
  },
  {
    value: "Tibetan Terrier",
    label: "Tibetan Terrier",
  },
  {
    value: "Canadian Eskimo Dog",
    label: "Canadian Eskimo Dog",
  },
  {
    value: "Samoyed",
    label: "Samoyed",
  },
  {
    value: "Hanoverian Scent Hound",
    label: "Hanoverian Scent Hound",
  },
  {
    value: "Hellenic Hound",
    label: "Hellenic Hound",
  },
  {
    value: "Bichon Frise",
    label: "Bichon Frise",
  },
  {
    value: "Pudelpointer",
    label: "Pudelpointer",
  },
  {
    value: "Bavarian Mountain Scent Hound",
    label: "Bavarian Mountain Scent Hound",
  },
  {
    value: "Chihuahua",
    label: "Chihuahua",
  },
  {
    value: "French Tricolour Hound",
    label: "French Tricolour Hound",
  },
  {
    value: "French White & Black Hound",
    label: "French White & Black Hound",
  },
  {
    value: "Frisian Water Dog",
    label: "Frisian Water Dog",
  },
  {
    value: "Stabijhoun",
    label: "Stabijhoun",
  },
  {
    value: "Dutch Shepherd Dog",
    label: "Dutch Shepherd Dog",
  },
  {
    value: "Drentsche Partridge Dog",
    label: "Drentsche Partridge Dog",
  },
  {
    value: "Fila Brasileiro",
    label: "Fila Brasileiro",
  },
  {
    value: "Landseer (European Continental Type)",
    label: "Landseer (European Continental Type)",
  },
  {
    value: "Lhasa Apso",
    label: "Lhasa Apso",
  },
  {
    value: "Afghan Hound",
    label: "Afghan Hound",
  },
  {
    value: "Serbian Tricolour Hound",
    label: "Serbian Tricolour Hound",
  },
  {
    value: "Tibetan Mastiff",
    label: "Tibetan Mastiff",
  },
  {
    value: "Tibetan Spaniel",
    label: "Tibetan Spaniel",
  },
  {
    value: "Deutsch Stichelhaar",
    label: "Deutsch Stichelhaar",
  },
  {
    value: "Little Lion Dog",
    label: "Little Lion Dog",
  },
  {
    value: "Xoloitzcuintle",
    label: "Xoloitzcuintle",
  },
  {
    value: "Great Dane",
    label: "Great Dane",
  },
  {
    value: "Australian Silky Terrier",
    label: "Australian Silky Terrier",
  },
  {
    value: "Norwegian Buhund",
    label: "Norwegian Buhund",
  },
  {
    value: "Mudi",
    label: "Mudi",
  },
  {
    value: "Hungarian Wire-Haired Pointer",
    label: "Hungarian Wire-Haired Pointer",
  },
  {
    value: "Hungarian Greyhound",
    label: "Hungarian Greyhound",
  },
  {
    value: "Hungarian Hound - Transylvanian Scent Hound",
    label: "Hungarian Hound - Transylvanian Scent Hound",
  },
  {
    value: "Norwegian Elkhound Grey",
    label: "Norwegian Elkhound Grey",
  },
  {
    value: "Alaskan Malamute",
    label: "Alaskan Malamute",
  },
  {
    value: "Slovakian Hound",
    label: "Slovakian Hound",
  },
  {
    value: "Bohemian Wire-Haired Pointing Griffon",
    label: "Bohemian Wire-Haired Pointing Griffon",
  },
  {
    value: "Cesky Terrier",
    label: "Cesky Terrier",
  },
  {
    value: "Atlas Mountain Dog (Aidi)",
    label: "Atlas Mountain Dog (Aidi)",
  },
  {
    value: "Pharaoh Hound",
    label: "Pharaoh Hound",
  },
  {
    value: "Majorca Mastiff",
    label: "Majorca Mastiff",
  },
  {
    value: "Havanese",
    label: "Havanese",
  },
  {
    value: "Polish Lowland Sheepdog",
    label: "Polish Lowland Sheepdog",
  },
  {
    value: "Tatra Shepherd Dog",
    label: "Tatra Shepherd Dog",
  },
  {
    value: "Pug",
    label: "Pug",
  },
  {
    value: "Alpine Dachsbracke",
    label: "Alpine Dachsbracke",
  },
  {
    value: "Akita",
    label: "Akita",
  },
  {
    value: "Shiba",
    label: "Shiba",
  },
  {
    value: "Japanese Terrier",
    label: "Japanese Terrier",
  },
  {
    value: "Tosa",
    label: "Tosa",
  },
  {
    value: "Hokkaido",
    label: "Hokkaido",
  },
  {
    value: "Japanese Spitz",
    label: "Japanese Spitz",
  },
  {
    value: "Chesapeake Bay Retriever",
    label: "Chesapeake Bay Retriever",
  },
  {
    value: "Mastiff",
    label: "Mastiff",
  },
  {
    value: "Norwegian Lundehund",
    label: "Norwegian Lundehund",
  },
  {
    value: "Hygen Hound",
    label: "Hygen Hound",
  },
  {
    value: "Halden Hound",
    label: "Halden Hound",
  },
  {
    value: "Norwegian Elkhound Black",
    label: "Norwegian Elkhound Black",
  },
  {
    value: "Saluki",
    label: "Saluki",
  },
  {
    value: "Siberian Husky",
    label: "Siberian Husky",
  },
  {
    value: "Bearded Collie",
    label: "Bearded Collie",
  },
  {
    value: "Norfolk Terrier",
    label: "Norfolk Terrier",
  },
  {
    value: "Canaan Dog",
    label: "Canaan Dog",
  },
  {
    value: "Greenland Dog",
    label: "Greenland Dog",
  },
  {
    value: "Brazilian Tracker",
    label: "Brazilian Tracker",
  },
  {
    value: "Norrbottenspitz",
    label: "Norrbottenspitz",
  },
  {
    value: "Croatian Shepherd Dog",
    label: "Croatian Shepherd Dog",
  },
  {
    value: "Karst Shepherd Dog",
    label: "Karst Shepherd Dog",
  },
  {
    value: "Montenegrin Mountain Hound",
    label: "Montenegrin Mountain Hound",
  },
  {
    value: "Old Danish Pointing Dog",
    label: "Old Danish Pointing Dog",
  },
  {
    value: "Grand Griffon Vendeen",
    label: "Grand Griffon Vendeen",
  },
  {
    value: "Coton De Tulear",
    label: "Coton De Tulear",
  },
  {
    value: "Lapponian Herder",
    label: "Lapponian Herder",
  },
  {
    value: "Spanish Greyhound",
    label: "Spanish Greyhound",
  },
  {
    value: "American Staffordshire Terrier",
    label: "American Staffordshire Terrier",
  },
  {
    value: "Australian Cattle Dog",
    label: "Australian Cattle Dog",
  },
  {
    value: "Chinese Crested Dog",
    label: "Chinese Crested Dog",
  },
  {
    value: "Icelandic Sheepdog",
    label: "Icelandic Sheepdog",
  },
  {
    value: "Beagle Harrier",
    label: "Beagle Harrier",
  },
  {
    value: "Eurasian",
    label: "Eurasian",
  },
  {
    value: "Dogo Argentino",
    label: "Dogo Argentino",
  },
  {
    value: "Australian Kelpie",
    label: "Australian Kelpie",
  },
  {
    value: "Otterhound",
    label: "Otterhound",
  },
  {
    value: "Harrier",
    label: "Harrier",
  },
  {
    value: "Collie Smooth",
    label: "Collie Smooth",
  },
  {
    value: "Border Collie",
    label: "Border Collie",
  },
  {
    value: "Romagna Water Dog",
    label: "Romagna Water Dog",
  },
  {
    value: "German Hound",
    label: "German Hound",
  },
  {
    value: "Black And Tan Coonhound",
    label: "Black And Tan Coonhound",
  },
  {
    value: "American Water Spaniel",
    label: "American Water Spaniel",
  },
  {
    value: "Irish Glen Of Imaal Terrier",
    label: "Irish Glen Of Imaal Terrier",
  },
  {
    value: "American Foxhound",
    label: "American Foxhound",
  },
  {
    value: "Russian-European Laika",
    label: "Russian-European Laika",
  },
  {
    value: "East Siberian Laika",
    label: "East Siberian Laika",
  },
  {
    value: "West Siberian Laika",
    label: "West Siberian Laika",
  },
  {
    value: "Azawakh",
    label: "Azawakh",
  },
  {
    value: "Dutch Smoushond",
    label: "Dutch Smoushond",
  },
  {
    value: "Shar Pei",
    label: "Shar Pei",
  },
  {
    value: "Peruvian Hairless Dog",
    label: "Peruvian Hairless Dog",
  },
  {
    value: "Saarloos Wolfhond",
    label: "Saarloos Wolfhond",
  },
  {
    value: "Nova Scotia Duck Tolling Retriever",
    label: "Nova Scotia Duck Tolling Retriever",
  },
  {
    value: "Dutch Schapendoes",
    label: "Dutch Schapendoes",
  },
  {
    value: "Nederlandse Kooikerhondje",
    label: "Nederlandse Kooikerhondje",
  },
  {
    value: "Broholmer",
    label: "Broholmer",
  },
  {
    value: "French White And Orange Hound",
    label: "French White And Orange Hound",
  },
  {
    value: "Kai",
    label: "Kai",
  },
  {
    value: "Kishu",
    label: "Kishu",
  },
  {
    value: "Shikoku",
    label: "Shikoku",
  },
  {
    value: "Wirehaired Slovakian Pointer",
    label: "Wirehaired Slovakian Pointer",
  },
  {
    value: "Majorca Shepherd Dog",
    label: "Majorca Shepherd Dog",
  },
  {
    value: "Great Anglo-French Tricolour Hound",
    label: "Great Anglo-French Tricolour Hound",
  },
  {
    value: "Great Anglo-French White And Black Hound",
    label: "Great Anglo-French White And Black Hound",
  },
  {
    value: "Great Anglo-French White & Orange Hound",
    label: "Great Anglo-French White & Orange Hound",
  },
  {
    value: "Medium-Sized Anglo-French Hound",
    label: "Medium-Sized Anglo-French Hound",
  },
  {
    value: "South Russian Shepherd Dog",
    label: "South Russian Shepherd Dog",
  },
  {
    value: "Russian Black Terrier",
    label: "Russian Black Terrier",
  },
  {
    value: "Caucasian Shepherd Dog",
    label: "Caucasian Shepherd Dog",
  },
  {
    value: "Canarian Warren Hound",
    label: "Canarian Warren Hound",
  },
  {
    value: "Irish Red And White Setter",
    label: "Irish Red And White Setter",
  },
  {
    value: "Kangal Shepherd Dog",
    label: "Kangal Shepherd Dog",
  },
  {
    value: "Czechoslovakian Wolfdog",
    label: "Czechoslovakian Wolfdog",
  },
  {
    value: "Polish Greyhound",
    label: "Polish Greyhound",
  },
  {
    value: "Korea Jindo Dog",
    label: "Korea Jindo Dog",
  },
  {
    value: "Central Asia Shepherd Dog",
    label: "Central Asia Shepherd Dog",
  },
  {
    value: "Spanish Water Dog",
    label: "Spanish Water Dog",
  },
  {
    value: "Italian Short-Haired Segugio",
    label: "Italian Short-Haired Segugio",
  },
  {
    value: "Thai Ridgeback Dog",
    label: "Thai Ridgeback Dog",
  },
  {
    value: "Parson Russell Terrier",
    label: "Parson Russell Terrier",
  },
  {
    value: "Saint Miguel Cattle Dog",
    label: "Saint Miguel Cattle Dog",
  },
  {
    value: "Brazilian Terrier",
    label: "Brazilian Terrier",
  },
  {
    value: "Australian Shepherd",
    label: "Australian Shepherd",
  },
  {
    value: "Italian Cane Corso",
    label: "Italian Cane Corso",
  },
  {
    value: "American Akita",
    label: "American Akita",
  },
  {
    value: "Jack Russell Terrier",
    label: "Jack Russell Terrier",
  },
  {
    value: "Presa Canario",
    label: "Presa Canario",
  },
  {
    value: "White Swiss Shepherd Dog",
    label: "White Swiss Shepherd Dog",
  },
  {
    value: "Taiwan Dog",
    label: "Taiwan Dog",
  },
  {
    value: "Romanian Mioritic Shepherd Dog",
    label: "Romanian Mioritic Shepherd Dog",
  },
  {
    value: "Romanian Carpathian Shepherd Dog",
    label: "Romanian Carpathian Shepherd Dog",
  },
  {
    value: "Australian Stumpy Tail Cattle Dog",
    label: "Australian Stumpy Tail Cattle Dog",
  },
  {
    value: "Russian Toy",
    label: "Russian Toy",
  },
  {
    value: "CimarrÃN Uruguayo",
    label: "CimarrÃN Uruguayo",
  },
  {
    value: "Polish Hunting Dog",
    label: "Polish Hunting Dog",
  },
  {
    value: "Bosnian And Herzegovinian - Croatian Shepherd Dog",
    label: "Bosnian And Herzegovinian - Croatian Shepherd Dog",
  },
  {
    value: "Danish-Swedish Farmdog",
    label: "Danish-Swedish Farmdog",
  },
  {
    value: "Romanian Bucovina Shepherd",
    label: "Romanian Bucovina Shepherd",
  },
  {
    value: "Thai Bangkaew Dog",
    label: "Thai Bangkaew Dog",
  },
  {
    value: "Miniature Bull Terrier",
    label: "Miniature Bull Terrier",
  },
  {
    value: "Lancashire Heeler",
    label: "Lancashire Heeler",
  },
  {
    value: "Segugio Maremmano",
    label: "Segugio Maremmano",
  },
  {
    value: "Kintamani-Bali Dog",
    label: "Kintamani-Bali Dog",
  },
  {
    value: "Prague Ratter",
    label: "Prague Ratter",
  },
  {
    value: "Bohemian Shepherd Dog",
    label: "Bohemian Shepherd Dog",
  },
  {
    value: "Yakutian Laika",
    label: "Yakutian Laika",
  },
  {
    value: "Estonian Hound",
    label: "Estonian Hound",
  },
  {
    value: "Miniature American Shepherd",
    label: "Miniature American Shepherd",
  },
  {
    value: "Transmontano Mastiff",
    label: "Transmontano Mastiff",
  },
  {
    value: "Continental Bulldog",
    label: "Continental Bulldog",
  },
  {
    value: "Valencian Terrier",
    label: "Valencian Terrier",
  },
];
